// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.48047 2.5L9.78125 2.875L12.6807 6.5H23V21H1V2.5H9.48047Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 2.5V4.5H13V2.5H23Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-page-tab-filled')
export default class PageTabFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'page-tab-filled',
    }
  }
}
